import AssessmentService from "@/client/services/api/AssessmentService";
import { useQuery } from "@tanstack/react-query";

export const useGetAssessmentScores = (userAssessmentId: string) =>
  useQuery({
    // enabled: failed === true,
    queryKey: ["assessment-scores", { userAssessmentId }],
    queryFn: () => AssessmentService.getAssessmentScores(userAssessmentId),
  });
